import React from 'react';
import { Box, Menu, MenuItem } from '@mui/material';
import { Add as AddIcon, CloudDownload as ExportIcon } from '@mui/icons-material';
import {
  FilterToolbarGradientButton,
  FilterToolbarOutlinedButton,
} from '../../../styles/theme/filterToolbarButtons';
import { usePhysicalCountActionButtons } from './PhysicalCountActionButtons.hooks';
import { usePermission } from '../../../hooks/usePermission';
import { INVENTORY_PERMISSIONS } from '../../../constants/permissions.constants';

/** Oculto por ahora: export de Control de Inventario Físico no es necesario. */
const SHOW_PHYSICAL_COUNT_EXPORT = false;

export interface PhysicalCountActionButtonsProps {
  onNewSession: () => void;
  onExport: (locationId: number) => void;
  locations: Array<{ id: number; name: string }>;
}

const PhysicalCountActionButtons: React.FC<PhysicalCountActionButtonsProps> = ({
  onNewSession,
  onExport,
  locations = [],
}) => {
  const canCreate = usePermission(INVENTORY_PERMISSIONS.PHYSICAL_COUNT.CREATE);
  const hasExportPermission = usePermission(INVENTORY_PERMISSIONS.PHYSICAL_COUNT.EXPORT);
  const canExport = SHOW_PHYSICAL_COUNT_EXPORT && hasExportPermission;
  const {
    exportAnchorEl,
    exportMenuOpen,
    handleNewSession,
    handleExportClick,
    handleExportClose,
    handleExportLocation,
  } = usePhysicalCountActionButtons({
    onNewSession,
    onExport,
    locations,
  });

  if (!canCreate && !canExport) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
      {canCreate && (
        <FilterToolbarGradientButton
          variant="contained"
          size="medium"
          onClick={handleNewSession}
          startIcon={<AddIcon />}
          sx={{ minWidth: 140 }}
        >
          Nueva sesión
        </FilterToolbarGradientButton>
      )}
      {canExport && (
        <FilterToolbarOutlinedButton
          variant="outlined"
          size="medium"
          onClick={handleExportClick}
          startIcon={<ExportIcon />}
          aria-controls={exportMenuOpen ? 'export-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={exportMenuOpen ? 'true' : undefined}
        >
          Exportar
        </FilterToolbarOutlinedButton>
      )}
      <Menu
        id="export-menu"
        anchorEl={exportAnchorEl}
        open={exportMenuOpen}
        onClose={handleExportClose}
        MenuListProps={{
          'aria-labelledby': 'export-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {locations.length === 0 ? (
          <MenuItem disabled>No hay sucursales</MenuItem>
        ) : (
          locations.map((loc) => (
            <MenuItem key={loc.id} onClick={() => handleExportLocation(loc.id)}>
              {loc.name}
            </MenuItem>
          ))
        )}
      </Menu>
    </Box>
  );
};

export default PhysicalCountActionButtons;
